export default __webpack_public_path__ + "static/team-img2-23ea522fc79d7c77023ccd10bed37302.jpg";